import { render, staticRenderFns } from "./crudInstancesServer.vue?vue&type=template&id=be6fc5aa"
import script from "./crudInstancesServer.vue?vue&type=script&lang=js"
export * from "./crudInstancesServer.vue?vue&type=script&lang=js"
import style0 from "./crudInstancesServer.vue?vue&type=style&index=0&id=be6fc5aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports